<template>
  <v-card elevation="1" :style="cssVars" class="card">
    <v-card-title class="d-flex justify-space-between accent--text pb-4">
      <span class="card-title">Предпросмотр документа</span>
      <span>
        <v-btn
          icon
          small
          title="Уменьшить масштаб"
          @click="zoomOut"
        >
          <v-icon>
            mdi-magnify-minus-outline
          </v-icon>
        </v-btn>
        <v-btn
          icon
          small
          title="Увеличить масштаб"
          @click="zoomIn"
        >
          <v-icon>
            mdi-magnify-plus-outline
          </v-icon>
        </v-btn>
        <v-btn
          icon
          small
          title="Распечатать документ"
          @click="printDoc"
        >
          <v-icon>
            mdi-printer
          </v-icon>
        </v-btn>
      </span>
    </v-card-title>
    <v-card-text>
      <div class="canvas_container" v-if="file">
        <canvas ref="pdfRenderer"></canvas>
      </div>

      <div class="no-content" v-else>
        <v-icon size="80">
          mdi-cat
        </v-icon>
      </div>

      <div class="d-flex justify-center" v-if="file">
        <div class="d-flex align-center mt-2">
          <v-icon
            :disabled="fileState.currentPage === 1"
            color="lightGrey"
            class="mr-3"
            title="Предыдущая страница"
            @click="goPrevious"
          >
            mdi-chevron-left
          </v-icon>

          <span class="accent--text page-info">
          Страница {{ fileState.currentPage }} из {{ fileState.totalPages }}
        </span>

          <v-icon
            :disabled="fileState.currentPage === fileState.totalPages"
            color="lightGrey"
            class="ml-3"
            title="Следующая страница"
            @click="goNext"
          >
            mdi-chevron-right
          </v-icon>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// import { Document } from "../../models";
// import { NestedDoc } from "../../models/documents";
// import axios from 'axios'
import printJS from 'print-js'
import pdfjs from 'pdfjs-dist/build/pdf'
import { fileApi } from "@/api";
import download from "@/plugins/download";

export default {
  name: 'DocumentPreviewCard',

  props: {
    isfullscreen: Boolean,
    values: Object,
    trigerShowPrint: Boolean
  },

  data: () => ({
    file: null,
    fileState: {
      pdf: null,
      currentPage: 1,
      totalPages: 1,
      zoom: 0.750
    },
  }),


  async mounted() {
  },

  computed: {
    cssVars() {
      return {
        '--window-height': document.documentElement.clientHeight + 'px'
      }
    }
  },

  methods: {
    async showFile() {
      if(this.values) {
        try {
          const data = await fileApi.getFile(this.values.id)
          this.file = data
          const pdf = await pdfjs.getDocument(await data).promise

          this.fileState.pdf = pdf
          this.fileState.currentPage = 1
          this.fileState.totalPages = pdf._pdfInfo.numPages
          this.isfullscreen ?
              this.fileState.zoom = 2 :
              this.fileState.zoom = 0.750
          this.render()
        } catch (e) {
          this.$toastr('error', '', `Ошибка открытия файла`)
          console.log(e)
        } finally {
        }
      }
    },

    render() {
      this.fileState.pdf.getPage(this.fileState.currentPage).then((page) => {
        const canvas = this.$refs.pdfRenderer
        const ctx = canvas.getContext('2d')
        const viewport = page.getViewport({scale: this.fileState.zoom})

        canvas.width = viewport.width
        canvas.height = viewport.height

        page.render({canvasContext: ctx, viewport})
      })
    },

    goPrevious() {
      if (!this.fileState.pdf || this.fileState.currentPage === 1) return
      this.fileState.currentPage -= 1
      this.render()
    },

    goNext() {
      if (!this.fileState.pdf || this.fileState.currentPage >= this.fileState.pdf._pdfInfo.numPages) return
      this.fileState.currentPage += 1
      this.render()
    },

    zoomOut() {
      if (!this.fileState.pdf || this.fileState.zoom === 0.25) return
      this.fileState.zoom -= 0.125
      this.render()
    },

    zoomIn() {
      if (!this.fileState.pdf) return
      this.fileState.zoom += 0.125
      this.render()
    },

    printDoc() {
      if (this.file) {
        const fileLink = fileApi.getFileLink(this.values.id)
        printJS({printable: fileLink, type: 'pdf'})
      }
    },

    uncoverDocCard() {
      this.$emit('clickUncoverCollapseDocCard', true)
    },

    collapseDocCard() {
      this.$emit('clickUncoverCollapseDocCard', false)
    }
  },

  watch: {
    trigerShowPrint() {
      this.showFile()
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 20px !important;
}

.card-title {
  word-break: normal !important;
}

.canvas_container {
  min-height: calc(var(--card-height) - 120px);
  /*max-height: calc(var(--card-height) - 120px);
  overflow: auto;*/
  max-height: calc(var(--window-height) - 280px);
  overflow-y:scroll;

  text-align: center;
  border: 1px solid #dadada;
  border-radius: 4px;
}

.canvas_container2 {
  overflow-y:scroll
}

.no-content {
  min-height: 250px;
  /*max-height: calc(var(--card-height) - 120px);
  overflow: auto;*/
  overflow-y:scroll;

  /*text-align: center;*/
  border: 1px solid #dadada;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
